import {ThunkAction} from 'redux-thunk';
import {IStore} from '../interface';
import {Action} from 'redux';
import {
  getActivityJournals, removeActivityJournal, removeJournal
} from '../pageAsyncActions';
import {clearErrorAction, finishLoadingAction, startLoadingAction} from '../status/actions';
import {errorHandler} from '../errorHandler';
import {ToastKey} from '../../components/gritx-toast/ToastKeyEnum';
import {getActivityJournalsApi} from '../api/activityjournals';
import {setActivityJournals} from './actions';
import {removeDialogueApi} from '../api/dialogue';
import {loadJournalsAction} from '../journal/journalAsyncActions';

export const loadActivityJournalsAction = (): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getActivityJournals;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getActivityJournalsApi();

      dispatch(finishLoadingAction(actionKey));
      dispatch(setActivityJournals(data));
    } catch (e) {
      console.log('loadActivityJournalsAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadActivityJournalsAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const removeActivityJournalAction = (dialogId: number): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = removeActivityJournal;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      await removeDialogueApi(dialogId);
      dispatch(loadActivityJournalsAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('removeActivityJournal', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.RemoveJournalAction,
        actionKey,
        error: e
      }));
    }
  }
});
